import { useContext } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { IconName } from '@fortawesome/fontawesome-svg-core'
// evertel
import { Icon, Text, Badge, Col } from '@evertel/web/ui'
import { ThreadContext } from '../../Thread'

interface RightGutterProps {
    toggleAside: (option: string, intent: string) => void
    activeTab?: string
    roomNotificationsEnabled?: boolean
}


const RightGutter: React.FC<RightGutterProps> = observer(({
    toggleAside,
    activeTab,
    roomNotificationsEnabled,
    ...otherProps
}) => {

    const { threadController, setIsMessageSearchModalOpen } = useContext(ThreadContext)

    const showOption = (option: string) => {
        toggleAside(option, 'open')
    }

    return (

        <Col
            valign="top"
            className="right-gutter"
            {...otherProps}>
            <GutterItem
                id="search"
                onClick={() => setIsMessageSearchModalOpen(true)}
                icon="search"
                title="Search"
                ariaLabel="Search messages in this thread"
                activeTab={activeTab}
            />
            <GutterItem
                id="directory"
                onClick={() => showOption('directory')}
                icon="users"
                title="People"
                ariaLabel="View people in this thread"
                activeTab={activeTab}
            />
            <GutterItem
                id="media-search"
                onClick={() => showOption('media-search')}
                icon="file-alt"
                title="Files"
                ariaLabel="Search files in this thread"
                activeTab={activeTab}
            />
        </Col>
    )
})


interface ItemProps {
    id: string
    onClick: () => void
    icon: IconName
    title: string
    ariaLabel: string
    badgeCount?: number
    badgeColor?: string
    activeTab?: string
    color?: string
}

const GutterItem: React.FC<ItemProps> = observer(({
    id,
    onClick,
    icon,
    title,
    ariaLabel,
    badgeCount = 0,
    badgeColor = 'primary',
    activeTab,
    color = ''
}) => {
    const _classNames = classNames(
        'right-gutter-items',
        { 'active': activeTab === id }
    )

    const isExpanded = activeTab === id
    const panelId = `slidepanel-${id}`

    return (
        <button
            className={_classNames}
            onClick={onClick}
            aria-expanded={isExpanded}
            aria-controls={panelId}
            aria-haspopup="true"
            aria-label={`${ariaLabel}${badgeCount > 0 ? `, ${badgeCount} unread` : ''}`}
        >
            <div className="position-relative">
                <Icon
                    name={icon}
                    color={color}
                    aria-hidden="true"
                />
                { (badgeCount > 0) &&
                    <Badge
                        color={badgeColor}
                        size={10}
                        position="top-end"
                        shape="rounded-pill"
                        className="position-absolute translate-middle"
                        aria-hidden="true"
                    >
                        {<strong>{(badgeCount > 200) ? '200+' : badgeCount}</strong>}
                    </Badge>
                }
            </div>
            <Text
                color={color}>
                {title}
            </Text>
        </button>
    )
})

export { RightGutter }
